import { useEffect, useRef, useState } from "react";
import { Upload, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";
import api, { mediaUrl } from "@/lib/api";
import { Btn } from "@/components/admin/AdminUI";

export default function MediaAdmin() {
  const [media, setMedia] = useState([]);
  const [search, setSearch] = useState("");
  const [uploading, setUploading] = useState(false);
  const ref = useRef();

  const load = () => api.get(`/admin/media?search=${encodeURIComponent(search)}`).then((r) => setMedia(r.data || []));
  useEffect(() => { load(); }, [search]);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      for (const file of files) {
        const fd = new FormData(); fd.append("file", file);
        await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success("Archivos subidos"); load();
    } catch { toast.error("Error al subir"); }
    finally { setUploading(false); }
  };

  const del = async (id) => { if (!window.confirm("¿Eliminar archivo?")) return; await api.delete(`/admin/media/${id}`); load(); };
  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("URL copiada"); };

  return (
    <div>
      <header className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-4xl tracking-tight">Biblioteca Multimedia</h1>
        <Btn variant="accent" onClick={() => ref.current.click()} disabled={uploading} data-testid="upload-media-btn">
          <Upload size={15} /> {uploading ? "Subiendo…" : "Subir archivos"}
        </Btn>
        <input ref={ref} type="file" multiple accept="image/*,video/*" onChange={upload} className="hidden" />
      </header>

      <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por nombre…"
        className="bg-white border border-sunset-border px-3 py-2 text-sm focus:outline-none focus:border-sunset-accent mb-6 w-72" />

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {media.map((m) => (
          <div key={m.id} className="bg-white border border-sunset-border group" data-testid={`media-item-${m.id}`}>
            <div className="aspect-square bg-sunset-border overflow-hidden relative">
              {m.content_type?.startsWith("video") ? (
                <video src={mediaUrl(m.url)} className="w-full h-full object-cover" />
              ) : (
                <img src={mediaUrl(m.url)} alt="" className="w-full h-full object-cover" />
              )}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <button onClick={() => copy(mediaUrl(m.url))} className="bg-white p-2"><Copy size={14} /></button>
                <button onClick={() => del(m.id)} className="bg-white p-2 text-red-600"><Trash2 size={14} /></button>
              </div>
            </div>
            <p className="text-[10px] text-sunset-muted p-2 truncate">{m.original_filename}</p>
          </div>
        ))}
        {media.length === 0 && <p className="col-span-full text-center text-sunset-muted py-16">Aún no hay archivos.</p>}
      </div>
    </div>
  );
}
